import ReqClient from './request.class'

// 新建推广计划
export async function creatCampaign(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/campaign/create/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据id获取推广计划获取推广计划
export async function getCampaign(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/campaign/get',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新推广计划
export async function uploadCampaign(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/campaign/update/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加广告组
export async function addAdgroup(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/ad/addplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告组详情
export async function getAdgroup(params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/queryByAdIdAndMediaId',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新广告组
export async function updateAdgroup(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/ad/updateplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取人群包
export async function getAudience(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getCustomAudiences',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取定向标签（兴趣、行为）
export async function getRecomment(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getTargetingTag',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取地域
export async function getRegion(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getRegion',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取手机品牌
export async function getDevice(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getDevice',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取移动媒体类型
export async function getMobileMediaType(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getMobile',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取定向列表
export async function getTargeting(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getTargeting',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取应用ID
export async function getPromotedObject(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getPromotedObject',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建应用ID
export async function addPromotedObject(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/addPromotedObject',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意规格模板
export async function getAdcreativeTemplates(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getAdcreativeTemplates',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取模板详情
export async function getAdCreativeTemplatesByID(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getAdcreativeTemplateDetailById',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 获取模板列表
export async function getAdcreativeTemplateList(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getAdcreativeTemplateList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 预估受众人群
export async function estimateAudience(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/estimationGet',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 判断广告组是否有创意
export async function existCreative(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/hasCreative',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取落地页地址
export async function getPages(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getPages',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取视频列表
export async function getVideos(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getVideo',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取图片列表
export async function getImages(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getImage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传单个图片
export async function uploadTencentImage(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/uploadImage',
    method: 'POST',
    timeout: 300000,
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传单个视频
export async function uploadTencentVedio(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/uploadVedio',
    method: 'POST',
    timeout: 300000,
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意详情
export async function getCreative(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/creative/get',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建创意详情
export async function creatCreative(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/creative/create/',
    method: 'POST',
    timeout: 300000,
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改创意详情
export async function editCreative(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/creative/update/',
    method: 'POST',
    timeout: 300000,
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取行为分类
export async function getActionInterestCategory(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getTargetingTag',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取兴趣分类
export async function getKeywordSuggest(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getTargetingTag',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量验证兴趣行为动态词
export async function betchVaildKeyword(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getTargetingTag',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取原生落地页
export async function getWechatPagesGet(params) {
  const Req = new ReqClient({
    // url: '/api/guangdiantong/tool/getAllPages',
    url: '/api/guangdiantong/tool/wechatPagesGet',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取蹊径落地页
export async function getXijingPages(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getAllXijinPages',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取腾讯广告官方落地页
export async function getGdtOfficialPages(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getAllOfficialPages',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 所选广告组中是否存在
export async function existWechatAd(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/ad/existWechatAd/',
    method: 'POST',
    timeout: 300000,
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取优量汇流量包
export async function getUnionPositionPackages(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getUnionPositionPackages',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取微信定投
export async function getWechatPositions(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getSceneSpecTags',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询腾讯广告游戏数据助推数据
export async function getTencentHelper(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/queryAdBoost',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改腾讯广告游戏数据助推数据
export async function updateTencentHelper(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/updateAdBoost',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取预约投放转化列表
export async function getConversionsList(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getConversions',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取投放素材标签
export async function getMaterialTags(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/materialLabelsGet',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除投放素材标签
export async function removeMaterialTags(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/materialLabelsDel',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 新增投放素材标签
export async function addMaterialTags(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/materialLabelsAdd',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 验证腾讯广告3.0广告是否重复
export async function checkAdRepeat(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/checkAdSimilar',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取弹幕
export async function getBarrageList(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/barrageGet',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取搜索广告关键词
export async function getSearchAdBidKeywordList(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getBidWord',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取腾讯广告授权
export async function getGdtUserToken(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getGdtUserToken',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 设置腾讯广告授权
export async function setGdtUserToken(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/setGdtUserToken',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取腾讯广告自动哈任务授权通知人员
export async function getGdtAuthUserConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/thirdAdLog/getTokenConfigAlert',
    method: 'get',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 设置腾讯广告自动哈任务授权通知人员
export async function setGdtAuthUserConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/thirdAdLog/updateTokenConfigAlert',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
